<template>
  <div class="columns">
    <div class="column is-6">
      <b-field label="Zona">
        <b-select
          :value="zona.id"
          type="is-info"
          :expanded="true"
          placeholder="Zona"
          @input="setZonaHandle"
        >
          <option v-for="option in zonas" :key="option.id" :value="option.id">
            {{ option.nombre }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field label="Nº Ítems">
        <b-select
          :value="tamanoPagina"
          type="is-info"
          placeholder="N° Ítems"
          expanded
          @input="setPageSizeHandle"
        >
          <option v-for="option in tamanos" :key="option" :value="option">
            {{ option }}
          </option>
        </b-select>
      </b-field>
    </div>
    <div class="column is-3">
      <b-field label="Por fecha">
        <b-switch :value="pedidosHoy" @input="setPedidosHoyHandle"
          >S&oacute;lo hoy</b-switch
        >
      </b-field>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'Filtros',
  computed: {
    ...mapGetters('monitor', ['tamanos']),
    ...mapGetters('monitorZona', ['zonas', 'zona']),
    modulo() {
      return 'monitorZona'
    },
    tamanoPagina() {
      return this.$store.getters['monitorZona/tamanoPagina']
    },
    pedidosHoy() {
      return this.$store.getters['monitorZona/pedidosHoy']
    }
  },
  mounted() {
    this.getZonas()
  },
  methods: {
    setPageSizeHandle(newValue) {
      return this.$store
        .dispatch(`${this.modulo}/setPageSize`, newValue)
        .catch((error) => this.procesarError(error))
    },
    setPedidosHoyHandle(newValue) {
      return this.$store
        .dispatch(`${this.modulo}/setPedidosHoy`, newValue)
        .catch((error) => this.procesarError(error))
    },
    setZonaHandle(newValue) {
      return this.$store
        .dispatch(`${this.modulo}/setZona`, newValue)
        .catch((error) => this.procesarError(error))
    },
    async getZonas() {
      return this.$store
        .dispatch('monitorZona/getZonas')
        .catch((error) => this.procesarError(error))
    }
  }
}
</script>
